import lrInput from './_src/lrInput.vue'

lrInput.install = function(Vue) {
  Vue.component(lrInput.name, lrInput)
}

export default lrInput